<template>
  <div class="container-fluid py-3">
    <div class="d-flex align-items-center mb-3">
      <span class="mr-2" style="color:#FF0013; font-size:1.1rem; font-weight:700">Tron</span>
      <h5 class="mb-0 mr-3">Transaction History</h5>
      <router-link to="/tron" class="btn btn-sm btn-outline-secondary mr-2">← Wallet</router-link>
      <router-link :to="address ? '/tron/graph?address=' + address : '/tron/graph'" class="btn btn-sm btn-outline-danger">⬡ Flow Graph</router-link>
    </div>

    <div class="row mb-3">
      <div class="col-md-6">
        <div class="input-group input-group-sm">
          <input class="form-control" v-model="address" placeholder="Tron address (T…)" @keyup.enter="load" />
          <div class="input-group-append">
            <button class="btn btn-danger" @click="load" :disabled="loading">
              {{ loading ? 'Loading…' : 'Load' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <TxTable :txs="txs" :loading="loading" accent-color="#FF0013" />
  </div>
</template>

<script>
import TxTable from '../components/TxTable.vue';
import { fetchTronTxs, fetchTronTrc20Txs } from '../services/txService';

export default {
  name: 'TronTransactions',
  components: { TxTable },
  data() {
    return { address: '', txs: [], loading: false };
  },
  methods: {
    async load() {
      if (!this.address.trim()) return;
      this.loading = true;
      try {
        const [native, trc20] = await Promise.all([
          fetchTronTxs(this.address.trim()),
          fetchTronTrc20Txs(this.address.trim()),
        ]);
        this.txs = [...native, ...trc20].sort((a, b) => b.timestamp - a.timestamp);
      }
      catch (e) { alert('Error: ' + e.message); }
      finally { this.loading = false; }
    },
  },
  mounted() {
    const w = this.$store && this.$store.state.wallets.tron;
    if (w && w.address) { this.address = w.address; this.load(); }
  },
};
</script>
